var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFabric48Color(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-7e9afc4afb23aa85__icon-4d039b80c4be800a__a)",
    fillRule: "evenodd",
    d: "m5.64 31.6-.586 2.144c-.218.685-.524 1.693-.689 2.59a5.629 5.629 0 0 0 4.638 7.588c.792.114 1.688.108 2.692-.04l4.613-.636a2.924 2.924 0 0 0 2.421-2.127l3.175-11.662L5.64 31.599Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-fbd56b0a81152ef4__icon-78f52e20309b156b__b)",
    d: "M10.14 32.152c-4.863.753-5.861 4.423-5.861 4.423l4.656-17.11 24.333-3.292-3.318 12.052a1.706 1.706 0 0 1-1.388 1.244l-.136.022-18.423 2.684.137-.023Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-971ae08ec7f45454__icon-77e9c21df46e5459__c)",
    fillOpacity: 0.8,
    d: "M10.14 32.152c-4.863.753-5.861 4.423-5.861 4.423l4.656-17.11 24.333-3.292-3.318 12.052a1.706 1.706 0 0 1-1.388 1.244l-.136.022-18.423 2.684.137-.023Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-006ae52c58818f34__icon-fefad3b496a01348__d)",
    d: "m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-b20c75ab267ca94a__icon-6e8dfaf161507040__e)",
    d: "m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-a92f6eee55b4848c__icon-736fd316b8a72f77__f)",
    fillOpacity: 0.4,
    d: "m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-f38431b998350117__icon-41e6540ecda9967b__g)",
    d: "M12.899 21.236c-3.901.706-4.87 1.962-5.514 3.932L4.279 36.577s.992-3.633 5.796-4.41l18.352-2.673.136-.022a1.707 1.707 0 0 0 1.388-1.244l2.73-9.915-19.782 2.923Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-1100149c8c650d8a__icon-5deb3b0bc4d268e5__h)",
    fillOpacity: 0.2,
    d: "M12.899 21.236c-3.901.706-4.87 1.962-5.514 3.932L4.279 36.577s.992-3.633 5.796-4.41l18.352-2.673.136-.022a1.707 1.707 0 0 0 1.388-1.244l2.73-9.915-19.782 2.923Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-9a3ccf482b635fc2__icon-246be254e9c09726__i)",
    fillRule: "evenodd",
    d: "M10.075 32.167c-4.06.657-5.392 3.345-5.71 4.164a5.629 5.629 0 0 0 4.638 7.59c.792.114 1.688.108 2.692-.039l4.613-.637a2.924 2.924 0 0 0 2.421-2.127l2.894-10.633-11.547 1.683-.001-.001Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-7e9afc4afb23aa85__icon-4d039b80c4be800a__a",
    x1: 12.953,
    x2: 12.953,
    y1: 44.001,
    y2: 29.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#2AAC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#239C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#177E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#0E6961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#095D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#085954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-fbd56b0a81152ef4__icon-78f52e20309b156b__b",
    x1: 31.331,
    x2: 17.286,
    y1: 33.448,
    y2: 18.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#ABE88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#2AAA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#117865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-971ae08ec7f45454__icon-77e9c21df46e5459__c",
    x1: -3.182,
    x2: 10.183,
    y1: 32.706,
    y2: 28.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD6F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-006ae52c58818f34__icon-fefad3b496a01348__d",
    x1: 7.013,
    x2: 42.589,
    y1: 15.219,
    y2: 15.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#25FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#55DDB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-b20c75ab267ca94a__icon-6e8dfaf161507040__e",
    x1: 7.013,
    x2: 39.06,
    y1: 10.247,
    y2: 25.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#60E9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#6DE9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#ABE88E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-a92f6eee55b4848c__icon-736fd316b8a72f77__f",
    x1: 9.978,
    x2: 27.404,
    y1: 13.031,
    y2: 16.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-f38431b998350117__icon-41e6540ecda9967b__g",
    x1: 15.756,
    x2: 16.168,
    y1: 27.96,
    y2: 15.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#063D3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#063D3B",
    stopOpacity: 0.237
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#063D3B",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-1100149c8c650d8a__icon-5deb3b0bc4d268e5__h",
    x1: 2.81,
    x2: 17.701,
    y1: 26.744,
    y2: 29.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-9a3ccf482b635fc2__icon-246be254e9c09726__i",
    x1: 13.567,
    x2: 10.662,
    y1: 39.97,
    y2: 25.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#063D3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#063D3B",
    stopOpacity: 0.135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#063D3B",
    stopOpacity: 0.599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#063D3B",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063D3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabric48Color);
export default __webpack_public_path__ + "static/media/fabric_48_color.e7d044ab5b8400233075660a461fc5ed.svg";
export { ForwardRef as ReactComponent };